import { LoginQuestionTypeDTO } from '@/api/account-controller/DTOs';
import { QuestionType } from '@/forms/typings';

export const adaptLoginQuestionTypeToQuestionType = (
  loginQuestionType: LoginQuestionTypeDTO,
): QuestionType => {
  switch (loginQuestionType) {
    case LoginQuestionTypeDTO.Unknown:
      return QuestionType.Unknown;
    case LoginQuestionTypeDTO.FirstName:
      return QuestionType.FirstName;
    case LoginQuestionTypeDTO.LastName:
      return QuestionType.LastName;
    case LoginQuestionTypeDTO.NPI:
      return QuestionType.NPI;
    case LoginQuestionTypeDTO.SSNLast4Digits:
      return QuestionType.SSNLast4Digits;
    case LoginQuestionTypeDTO.DOB:
      return QuestionType.DOB;
  }
};
